export default {
    points:"",
    attached_photos:"",
    category:"",
    created_by:"",
    icon_url:"",
    toolbox_id: "",
    toolbox_topic: "",
    created_timestamp: ""

}